import { useState, useEffect } from 'react';
import { getAuthAsync } from 'configuration';
import { onAuthStateChanged } from 'firebase/auth';

/**
 * Returns true once Firebase has confirmed a valid auth token is in place.
 * Used to gate Firestore reads/subscriptions in food-deal-ui where
 * the custom token is exchanged asynchronously after the session cookie check.
 * Prevents permission-denied errors from firing before the token propagates.
 */
export function useFirebaseReady() {
  const [firebaseReady, setFirebaseReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let unsubscribe = () => {};

    getAuthAsync().then((auth) => {
      if (cancelled) return;

      // If already signed in, resolve immediately
      if (auth.currentUser) {
        setFirebaseReady(true);
        return;
      }

      // Otherwise wait for the first auth state change
      unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user && !cancelled) {
          setFirebaseReady(true);
        }
      });
    });

    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);

  return firebaseReady;
}
